export default "__VITE_ASSET__DpZibo8g__"